module.exports = __webpack_public_path__ + "static/media/024-server-1.6cc31c10.svg";